import React, { useEffect, lazy, Suspense } from 'react';

import useApi, { GET_AVAILABLE_INSTRUMENTS } from 'hooks/useApi';
import LoadingSpinner from 'components/LoadingSpinner';

import Container from 'components/Container';
import Page from 'layout/Page';
import { Typography } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';

const DashboardsList = lazy(() => import('../DashboardsList/DashboardsList'));

const Instruments = () => {
  const [state, makeRequest] = useApi();
  const { data } = state;

  const useStyles = makeStyles(() => ({
    title: {
      textAlign: 'left',
      font: '20px',
      letterSpacing: '0px',
      padding: '18px',
      outline: 'none'
    }
  }));

  const classes = useStyles();

  useEffect(() => {
    makeRequest(GET_AVAILABLE_INSTRUMENTS());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Page title="Instruments">
      <Container center maxWidth="xl">
        <Suspense fallback={<LoadingSpinner />}>
          {data?.length >= 0 ? (
            <DashboardsList linkUrlPrefix="canned" items={data} />
          ) : (
            <Typography variant="h5" className={classes.title}>
              No 'Instruments' are available.
            </Typography>
          )}
        </Suspense>
      </Container>
    </Page>
  );
};

export default Instruments;
